import React from "react";
import DogIcon from "./DogIcon";

const Preloader: React.FC = () => {
    return (
        <div className="blj-store-locator-preloader">
            <div className="blj-store-locator-preloader__spinner">
                <DogIcon/>
            </div>
            <div className="blj-store-locator-preloader__text">
                Loading...
            </div>
        </div>
    );
}

export default Preloader;